import React, { forwardRef, useRef } from "react";
import { Link } from "react-router-dom";
import { useDropdownFilter } from "../Custom_Hooks/useDropdownFilter";
import { useDropdownKeyboardNavigation } from "../Custom_Hooks/useDropdownKeyboardNavigation";
import { useDropdownScroll } from "../Custom_Hooks/useDropdownScroll";
import { flushSync } from "react-dom";
import { useDispatch } from "react-redux";
import { closeModal, openModal } from "../../redux/actions/action-creator";

// Helper function to format balance with Cr/Dr
const formatBalance = (balance) => {
  // debugger
  if (
    balance === null ||
    balance === undefined ||
    balance === "" ||
    balance === 0 ||
    balance === "0"
  ) {
    return "0.00";
  }

  const numBalance = parseFloat(balance);
  return numBalance;

  // if (isNaN(numBalance)) {
  //     return balance;
  // }

  // const absBalance = Math.abs(numBalance);
  // if(absBalance === 0){
  //     return ''
  // }
  // if (numBalance < 0) {
  //     return `${absBalance} Cr`;
  // } else {
  //     return `${absBalance} Dr`;
  // }
  // debugger
};

const DropdownLayout_1 = forwardRef(
  (
    {
      title,
      state,
      input_value,
      input_key,
      input_blc,
      input_id,
      rawData,
      data,
      setData,
      setSubmitConfirm,
      inputRefs,
      handleDropdownClick,
      className,
      index,
    },
    ref
  ) => {
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const { filteredData } = useDropdownFilter({
      dataList: rawData,
      searchInput: input_value,
      inputRef: ref,
      isDynamic: false,
    });
    let is_dropdown_clicked = false;
    const { selectedItemIndex, setSelectedItemIndex } =
      useDropdownKeyboardNavigation({
        items: filteredData,
        state,
        inputRef: ref,
        onItemSelect: (item) => {
          is_dropdown_clicked = true;
          selectedDataHandle(item);
        },
        onItemAltCSelect: (item) => {
          // Close the current dropdown and open appropriate creation modal
          dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key));

          // Determine which modal to open based on input_key
          if (input_key === "godown_location" || input_key === "location") {
            dispatch(openModal("godownCreateVoucher"));
          } else if (input_key === "item_name") {
            // For item fields, open stock item creation modal
            dispatch(openModal("stockItemCreate"));
          } else if (input_key === "under_id" || input_key === "group_id") {
            // For group fields in ledger, open group creation modal
            dispatch(openModal("create_group_under"));
          } else {
            dispatch(openModal("ledgerCreate"));
          }
        },
        input_value,
      });

    const selectedDataHandle = (item) => {
      flushSync(() => {
        const updatedData = { ...data };
        const itemName = item?.name || item?.ledger_name || item?.symbol;

        if (typeof index !== "number") {
          updatedData[input_key] = itemName;

          if (input_id) {
            updatedData[input_id] = item?.id; // Update with item id if input_id exists
          }
          if (input_blc) {
            updatedData[input_blc] =
              data.account === item.ledger_name
                ? data.account_ledger_balance
                : formatBalance(item?.opening_balance);
          }
        } else {
          // Update array fields within `data_item`
          updatedData.data_item = (data.data_item || []).map((item_data, i) =>
            i === index
              ? {
                ...item_data,
                [input_key]: itemName,
                ...(input_id ? { [input_id]: item?.id } : {}),
              }
              : item_data
          );
        }

        if (input_id === "group_id") {
          updatedData["group_slug"] = item?.slug; // Add slug if input_id is 'group_id'
          updatedData["nature_of_group"] = item?.nature_of_group; // Add nature_of_group if input_id is 'group_id'
          if (["Assets", "Expenses"].includes(item?.nature_of_group)) {
            updatedData["type"] = "Dr";
          } else if (["Liabilities", "Income"].includes(item?.nature_of_group)) {
            updatedData["type"] = "Cr";
          }
        }
        if (input_id === "under") {
          updatedData["nature_of_group"] = item?.nature_of_group; // Add nature_of_group if input_id is 'group_id'
        }
        if (input_key === "unit_name") {
          updatedData["unit_name_first_unit"] = item?.first_unit
            ? item?.first_unit
            : "";
          updatedData["unit_name_second_unit"] = item?.second_unit
            ? item?.second_unit
            : "";
          updatedData["unit_name_third_unit"] = item?.third_unit
            ? item?.third_unit
            : "";
          updatedData["unit_name_fourth_unit"] = item?.fourth_unit
            ? item?.fourth_unit
            : "";
          updatedData["unit_name_fifth_unit"] = item?.fifth_unit
            ? item?.fifth_unit
            : "";
          updatedData["default_unit_id"] = item?.fifth_unit
            ? item?.fifth_unit
            : item?.fourth_unit
              ? item?.fourth_unit
              : item?.third_unit
                ? item?.third_unit
                : item?.second_unit
                  ? item?.second_unit
                  : item?.first_unit
                    ? item?.first_unit
                    : data?.default_unit_id
                      ? data?.default_unit_id
                      : '';
          updatedData["default_unit"] = item?.fifth_unit
            ? item?.fifth_unit
            : item?.fourth_unit
              ? item?.fourth_unit
              : item?.third_unit
                ? item?.third_unit
                : item?.second_unit
                  ? item?.second_unit
                  : item?.first_unit
                    ? item?.first_unit
                    : data?.default_unit
                      ? data?.default_unit
                      : '';
          updatedData["default_unit_rate_id"] = item?.fifth_unit
            ? item?.fifth_unit
            : item?.fourth_unit
              ? item?.fourth_unit
              : item?.third_unit
                ? item?.third_unit
                : item?.second_unit
                  ? item?.second_unit
                  : item?.first_unit
                    ? item?.first_unit
                    : data?.default_unit_rate_id
                      ? data?.default_unit_rate_id
                      : '';
          updatedData["default_unit_rate"] = item?.fifth_unit
            ? item?.fifth_unit
            : item?.fourth_unit
              ? item?.fourth_unit
              : item?.third_unit
                ? item?.third_unit
                : item?.second_unit
                  ? item?.second_unit
                  : item?.first_unit
                    ? item?.first_unit
                    : data?.default_unit_rate
                      ? data?.default_unit_rate
                      : '';
        }
        if (input_key === "party_bill_to") {
          updatedData["party_bill_to_ledger_id"] = item?.id;
          updatedData["party_bill_to"] = item?.ledger_name || item?.name;
          updatedData["partry_bill_to_current_balance"] = formatBalance(
            item?.opening_balance
          );
          updatedData["party_bill_to_mailing_name"] = item?.mailing_name;
          updatedData["bill_to_address"] = item?.address;
          updatedData["bill_to_contact"] = item?.mobile_no;
          updatedData["party_ship_to_ledger_id"] = item?.id;
          updatedData["party_ship_to"] = item?.ledger_name || item?.name;
          updatedData["party_ship_to_current_balance"] = formatBalance(
            item?.opening_balance
          );
          updatedData["party_ship_to_mailing_name"] = item?.mailing_name;
          updatedData["ship_to_address"] = item?.address;
          updatedData["ship_to_contact"] = item?.mobile_no;
        }
        if (input_key === "party_ship_to") {
          updatedData["party_ship_to_ledger_id"] = item?.id;
          updatedData["party_ship_to"] = item?.ledger_name;
          updatedData["party_ship_to_current_balance"] = formatBalance(
            item?.opening_balance
          );
          updatedData["party_ship_to_mailing_name"] = item?.mailing_name;
          updatedData["ship_to_address"] = item?.address;
          updatedData["ship_to_contact"] = item?.mobile_no;
        }
        if (input_key === "alt_unit_name") {
          const unitKeys = [
            "first_unit",
            "second_unit",
            "third_unit",
            "fourth_unit",
            "fifth_unit",
          ];
          unitKeys.forEach((key, _index) => {
            updatedData[`alt_unit_name_${key}`] = item?.[key]
              ? item?.[key]
              : "" || "";
          });
          dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key));
        } else {
          dispatch(closeModal(typeof index === "number" ? `${input_key}${index} ` : input_key));
        }

        setData(updatedData);
      });

      // Handle Navigation after selection if dynamic (has index)
      if (typeof index === "number") {
        const fields = ["godown_name", "quantity", "rate", "per", "value"];
        const fieldIdx = fields.indexOf(input_key);
        if (fieldIdx !== -1 && fieldIdx < fields.length - 1) {
          const nextField = fields[fieldIdx + 1];

          // Special skips for Not Applicable units
          if (data?.unit_name === "Not Applicable" && input_key === "godown_name") {
            // This case might not be reached by DropdownLayout_1 but kept for consistency
          }

          const nextKey = `${nextField}${index} `;
          const nextRef =
            inputRefs?.current?.[nextKey] || inputRefs?.[nextKey]?.current;
          if (nextRef) {
            setTimeout(() => {
              nextRef.focus();
              if (nextRef.setSelectionRange)
                nextRef.setSelectionRange(0, nextRef.value?.length || 0);
            }, 50);
          }
        }
      }

      if (handleDropdownClick && is_dropdown_clicked) {
        handleDropdownClick(
          input_key,
          item?.ledger_name || item?.name || item?.symbol
        );
      }
    };

    useDropdownScroll({ dropdownRef, selectedItemIndex });

    return (
      <div
        className={`${className ? className : "dropdown-content-list"} ${state ? "show-list" : ""}`}
        style={typeof index === 'number' ? { position: 'absolute', width: '45%', top: '0', left: '40%' } : { position: "absolute", top: `0`, left: `40%` }}
      >
        <div
          className="col"
          style={{ background: "skyblue", position: "sticky", top: 0 }}
        >
          {title}
        </div>

        <div
          id="data"
          ref={dropdownRef}
          style={{ overflowY: "auto", maxHeight: "80.5vh" }}
        >
          {Array.isArray(filteredData) &&
            filteredData?.map((key, number) => {
              const name = key?.ledger_name || key?.name || key?.symbol;
              const formal_name = key?.formal_name;
              const type = key?.type;
              const balance = key?.opening_balance;
              const id = key?.id;
              const index = name
                ?.toLowerCase()
                ?.indexOf(input_value?.toLowerCase());
              return (
                <Link
                  className={`list  ${number === selectedItemIndex ? "selected" : ""
                    } ${['primary', 'not applicable', 'not available'].includes(name?.toLowerCase())
                      ? 'primary-icon'
                      : ''
                    }`}
                  id="list"
                  key={number}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedItemIndex(number);
                    if (number === selectedItemIndex) {
                      const item = filteredData[number];
                      is_dropdown_clicked = true;
                      selectedDataHandle(item);
                    }
                  }}
                >
                  <div className="row m-0">
                    <div className={formal_name ? "col-6 p-0" : "col-12 p-0"}>
                      {index !== -1 ? (
                        <>
                          {name?.substring(0, index)}
                          <span style={{ color: "red" }}>
                            {name?.substring(
                              index,
                              index + input_value?.length
                            )}
                          </span>
                          {name?.substring(index + input_value?.length)}
                        </>
                      ) : (
                        name
                      )}
                    </div>
                    {formal_name ? (
                      <div className="col-6">
                        {formal_name && type === "Simple"
                          ? `(${formal_name})`
                          : null}
                      </div>
                    ) : null}
                  </div>
                </Link>
              );
            })}
        </div>
      </div>
    );
  }
);

export default React.memo(DropdownLayout_1);
